module.exports = __webpack_public_path__ + "img/cam_tv.69184ab0.png";